import React from 'react';

// ROUTES
import * as routes from '../../settings/_routesSettings';

// COMPONENTS
// import { HomepageView } from './HomepageView';
import Homepage from './Homepage';

const HomepagePsic = () => {
  return (
    <Homepage
      filters
      planBox
      config={{
        type: 'PSIC',
        title: 'psicólogo',
        url: routes.HOME_PSIC,
        statusCode: 'STS24001',
        productCode: 'PRO01001',
      }}
    />
  );
};

export { HomepagePsic };
